import { Star, Users, Award } from 'lucide-react';

const TrustIndicators = () => {
  return (
    <div className="bg-gradient-to-b from-emerald-50/50 to-white py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {/* Rating */}
          <div className="flex flex-col items-center">
            <div className="flex items-center mb-2">
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" />
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400 ml-1" />
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400 ml-1" />
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400 ml-1" />
              <Star className="w-6 h-6 text-yellow-400 fill-yellow-400 ml-1" />
            </div>
            <p className="text-2xl font-bold text-gray-900">4.7 / 5</p>
            <p className="text-sm text-gray-600 mt-1">Note moyenne</p>
          </div>

          {/* Customers */}
          <div className="flex flex-col items-center">
            <Users className="w-8 h-8 text-emerald-600 mb-2" />
            <p className="text-2xl font-bold text-gray-900">+1000</p>
            <p className="text-sm text-gray-600 mt-1">Vacanciers équipés chaque saison</p>
          </div>

          {/* Recommendation */}
          <div className="flex flex-col items-center">
            <Award className="w-8 h-8 text-emerald-600 mb-2" />
            <p className="text-lg font-semibold text-gray-900">Recommandé</p>
            <p className="text-sm text-gray-600 mt-1">Par votre lieu de séjour</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;
